<template>
  <div class="layout">
    <header>
      <div class="header-content">
        <img src="@/assets/top_logo.png" />
        <!-- <nav>
          <div :class="getMenuClass('/home')" @click="toPath('/home')">Home</div>
          <div :class="getMenuClass('/download')" @click="toPath('/download')">Download</div>
        </nav> -->
      </div>
    </header>
    <div style="flex-grow: 1;">
      <router-view/>
    </div>
    <footer>
      <div class="footer-menu-bar">
        <div class="footer-menu" @click="openLink('/user_agreenment')">User Agreenment</div> |
        <div class="footer-menu" @click="openLink('/privacy_policy')">Privacy policy</div> |
        <div class="footer-menu" @click="openLink('/qa')">Q&A</div>
      </div>
      <div style="margin-top: 30px;">
        <div>tikshowservice@gmail.com</div>
        <div>©BestShort, All rights reserved. 2024 TIKSHOW LIMITED</div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      currentPath: ''
    }
  },
  created() {
    this.currentPath = this.$router.currentRoute.path;
  },
  watch: {
    $route: {
      handler: function(val, oldVal){
        this.currentPath = val.path;
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    toPath(path) {
      if (this.$router.currentRoute.path != path) {
        this.$router.push(path);
      }
    },
    getMenuClass(path) {
      if (this.currentPath == path) {
        return "menu active";
      } else {
        return "menu"
      }
    },
    openLink(path) {
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss">
.layout {
  background-color: #f6f5fa;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}

header {
  height: 72px;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  .header-content {
    width: 1520px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

nav {
  flex-grow: 1;
  text-align: left;
  .menu {
    display: inline-block;
    margin-left: 60px;
    font-weight: bold;
    color: #333333;
    font-size: 26px;
    font-family: Arial, Helvetica, sans-serif;
    cursor: pointer;
    &.active {
      color: #fe4f3e;
    }
    &:hover {
      color: #fe4f3e;
    }
  }
}

footer {
  background-color: #000;
  padding: 20px;
  color: #fff;
  text-align: center;
  font-size: 21px;
}

.footer-menu-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-menu {
  color: #ccc;
  font-size: 21px;
  cursor: pointer;
  padding: 0 20px;
}
.footer-menu::after {
	content: "";
	display: block;
  background-color: #ccc;
  width: 100%;
  height: 1px;
}
</style>
